import { render, staticRenderFns } from "./Water.vue?vue&type=template&id=528a0c9d&scoped=true&"
import script from "./Water.vue?vue&type=script&lang=js&"
export * from "./Water.vue?vue&type=script&lang=js&"
import style0 from "./Water.vue?vue&type=style&index=0&id=528a0c9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528a0c9d",
  null
  
)

export default component.exports